<template>
    <div>
        <div class="row">
            <!-- form -->
            <div :class="{'col-md-7': MaxScale === 'Monitor','col-md-12': MaxScale === 'miniMonitor'}" >
                <h4 class="mt-0 mb-3 text-dark"><i class="fa fa-file-text-o mr-2" aria-hidden="true"></i>Booking Form</h4>
                <b-form >
                    <label class="text-dark font-weight-bold">Location:</label>
                    <b-form-group
                        id="input-group-1"
                        label=""
                        label-for="input-1"
                        description=""
                        class="mt-0 mb-2"
                    >
                        <b-form-select v-model="formData.location" @change="fullControllLocation" id="input-1" :options="optionsLocation"></b-form-select>
                    </b-form-group>
                    <!-- alert detail -->
                    <b-alert v-if="checkDetailData(formData.location , 'detail') !== null" class="text-dark" show variant="dark-cus">
                        <b class="mt-0 mb-0">Location : Detail</b>
                        <br>
                        <span class="mt-0 mb-0" v-html="checkDetailData(formData.location , 'detail')"></span>
                    </b-alert>
                    <!-- alert detail -->
                    <!-- time -->
                    <label class="text-dark font-weight-bold">Time length:</label>
                    <b-form-group
                        id="input-group-3"
                        label-for="input-3"
                        description=""
                    >
                        <b-form-select @change="fullControll" v-model="formData.time" id="input-3" :options="optionsTime"></b-form-select>
                    </b-form-group>
                </b-form>
                <b-card-text class="mt-3 mb-0">
                    <h5 class="text-danger font-weight-bold"><i class="fa fa-exclamation-triangle mr-2" aria-hidden="true"></i>Rules and Regulations</h5>
                </b-card-text>
                <p class="mb-1 mt-2">1. You can book only once slot per booking.</p>
                <p class="mb-1 mt-2">2. The booking may be canceled within 15-minute prior to your booking time.</p>
                <p class="mb-1 mt-2">3. If you do not show up, you will be blocked from making another booking for 24 hours.</p>
                <p class="mb-3 mt-2">4. If you have encountered any problems please contact us via IC-Service at <b-link to="/icservice" >https://my.muic.io/#/icservice</b-link></p>
                <b-table 
                    :items="itemDay" 
                    :fields="fields" 
                    responsive
                    head-variant="dark"
                    small show-empty bordered
                    style="font-size:0.8rem;font-weight:600"
                >
                    <template v-slot:cell(b)="row">
                        <span v-if="row.item.date_permit">
                            <span v-if="row.item.b <= 0" class="text-danger">0</span>
                            <span v-else>{{  row.item.b }}</span>
                        </span>
                        <span v-else>-</span>
                    </template>
                    <template v-slot:cell(c)="row">
                        <div v-if="row.item.user_permit && row.item.date_permit && (row.item.b > 0)">
                            <b-button size="sm"  @click="addConfirm(row,row.item.a)" class="text-capitalize" variant="success"><i class="fa fa-check-square-o mr-1" aria-hidden="true"></i>Booking</b-button>
                        </div>
                        <div v-else-if="!row.item.date_permit">
                            <span class="font-weight-bold">closed</span>
                        </div>
                        <div v-else-if="row.item.b == 0">
                            <span class="font-weight-bold text-danger">Full</span>
                        </div>
                        <div v-else-if="!row.item.user_permit">
                            <i class="text-danger fa fa-times fa-lg"></i>
                        </div>
                    </template>
                </b-table>
            </div>
            <!-- log -->
            <div :class="{'col-md-5': MaxScale === 'Monitor','col-md-12': MaxScale === 'miniMonitor'}" >
                <h4 class="mt-0 mb-0 text-dark"><i class="fa fa-history mr-2" aria-hidden="true"></i>Booking History</h4>
                <div v-if="recordMe">
                    <b-list-group v-for="(item, index) in recordMe" :key="index" class="mt-2 mb-3">
                        <b-list-group-item :class="{'border-s': item.status === 'approved' ,'border-w': item.status !== 'approved'}">
                            <div class="d-flex w-100 justify-content-between">
                                <h4 class="mt-0 mb-1"><b>Booking ID : {{ zeroPad(item.id) }}</b></h4>
                                <b-button
                                    :disabled="!item.btndelChk"
                                    @click="infoDel(zeroPad(item.id), item.id)" class="mt-0 mb-0 float-right" size="sm" variant="danger"
                                >
                                        <i class="fa fa-trash" aria-hidden="true"></i>
                                </b-button>
                            </div>
                            <h5 class="text-capitalize mt-1 mb-2"><b><i class="fa fa-map-marker" aria-hidden="true"></i></b> : {{ item.recode_location }}</h5>
                            <p class="text-capitalize mt-1 mb-0"><b><i class="fa fa-calendar" aria-hidden="true"></i></b> : {{ moment(item.recode_date).format('ddd LL') }}</p>
                            <p class="text-capitalize mt-1 mb-0"><b><i class="fa fa-hourglass-end" aria-hidden="true"></i></b> : {{ item.recode_time }}</p>
                            <p class="text-capitalize mt-1 mb-0">
                                <b><i class="fa fa-tag" aria-hidden="true"></i></b> :
                                <b-badge class="h6 text-capitalize" variant="success" v-if="item.status === 'approved'">{{ item.status }}</b-badge>
                                <b-badge class="h6 text-capitalize" variant="secondary" v-else>{{ item.status }}</b-badge>
                            </p>
                            <p class="text-capitalize ml-0 mt-1 mb-0">
                                <b>Remark</b> : <span v-html="item.remark"></span>
                            </p>
                        </b-list-group-item>
                    </b-list-group>
                </div>
                <div v-else>
                    <p class="text-capitalize mt-1 mb-0"><b>No reserved.</b></p>
                </div>
            </div>
        </div>
        <!-- add modal -->
        <b-modal centered ref="bv-modal-con" id="bv-modal-con" hide-footer hide-header-close no-close-on-backdrop>
            <template v-slot:modal-title>
                <h5 class="font-weight-bold mt-2 mb-0">Are you sure you want to Booking ?</h5>
            </template>
            <h5 class="mt-2 mb-2">Please show your Booking to staff for approving.</h5>
            <h5 class="text-capitalize mt-1 mb-2"><b><i class="fa fa-map-marker" aria-hidden="true"></i></b> : {{ confirmModal.text_1 }}</h5>
            <p class="text-capitalize mt-1 mb-0"><b><i class="fa fa-calendar" aria-hidden="true"></i></b> : {{ confirmModal.text_2 }}</p>
            <p class="text-capitalize mt-1 mb-2"><b><i class="fa fa-hourglass-end" aria-hidden="true"></i></b> : {{ confirmModal.text_3 }}</p>
            <!-- REMARK -->
            <label class="text-dark font-weight-bold">Remark: (if any)</label>
            <b-form-group
                id="input-group-2"
                label-for="input-2"
                description=""
            >
                <b-form-textarea
                    v-model="formData.remark"
                    id="textarea"
                    placeholder="Enter remark..."
                    rows="3"
                    max-rows="6"
                ></b-form-textarea>
            </b-form-group>
            <hr>
            <div class="mt-3 mb-3 row">
                <div class="col-md-6">
                    <b-button class="mb-2" @click="addReserved" block variant="success">Yes</b-button>
                </div>
                <div class="col-md-6">
                    <b-button class="mb-2" @click="closeReserved" block variant="danger">No</b-button>
                </div>
            </div>
        </b-modal>
        <!-- del modal -->
        <b-modal centered ref="bv-modal-del" id="bv-modal-del" hide-footer hide-header-close no-close-on-backdrop>
            <template v-slot:modal-title>
                <h5 class="font-weight-bold mt-2 mb-0">Are you sure you want to Delete ?</h5>
                <h5 class="font-weight-bold mt-2 mb-0">Booking ID : {{ infoModal.id1 }}</h5>
            </template>
            <div class="mt-3 mb-3 row">
                <div class="col-md-6">
                    <b-button class="mb-2" @click="delReserved(infoModal.id2)" block variant="success">Yes</b-button>
                </div>
                <div class="col-md-6">
                    <b-button class="mb-2" @click="DelReserved"  block variant="danger">No</b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<style lang="scss" scoped>
    .border-s{ border-left: 5px solid #41B883; }
    .border-w{ border-left: 5px solid #969696; }
    .alert-info-cus {
        background-color: #c2f3ff;
        color: #000000;
    }
    .alert-dark-cus {
        color: #1b1e21;
        background-color: #eaeaea;
        border-color: #c6c8ca;
    }
    .alert-danger-cus {
        background-color: #ffa7a7;
        color: #292929;
    }
    .form-control {
        background-color: #ffffff;
        border: 1px solid #ced4da;
        border-radius: 4px;
        color: #000;
        font-size: 14px;
        transition: background-color 0.3s ease 0s;
        padding: 7px 18px;
        height: 40px;
        -webkit-box-shadow: none;
        box-shadow: none;
    }
    .font-thai{ font-family: 'Kanit', sans-serif; font-weight: 100; }
    .font-en{ font-family: 'Kanit', sans-serif; }
    .w-5{ width: 5%; }
    .w-20{ width: 20%; }
    .f-size{ font-size: 1rem; }
</style>

<script>
    const formReserved = {
        date:'',
        location:null,
        time:null,
        remark:null
    }
    export default {
        data() {
            return {
                AcceptChk: 'not_accepted',
                caseReserved:'Yes',
                special_date_show:false,
                formData: Object.assign({}, formReserved),
                optionsLocation:[],
                locationData:[],
                optionsTime:[{value: null, text: 'Please select time' , disabled: true}],
                recordMe:[],
                free:0,
                limit:0,
                used:0,
                window: {
                    width: 0,
                    height: 0
                },
                MaxScale:'Monitor',
                infoModal: {
                    id1: '',
                    id2: '',
                },
                permit:'',
                fields: [ 
                    {key: 'a',label: 'Date',class: 'f-size w-20',},
                    {key: 'b',label: 'Free',class: 'f-size text-center w-5',},
                    {key: 'c',label: 'Booking',class: 'f-size text-center w-5',},
                ],
                itemDay:[],
                itemDays:[],
                confirmModal: {
                    text_1: '',
                    text_2: '',
                    text_3: '',
                },
            }
        },
        created() {
            window.addEventListener('resize', this.handleResize);
            this.handleResize();
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize);
        },
        computed: {
            isForm(){
                return this.formData.date !== '' && this.formData.location !== null && this.formData.time !== null  && this.AcceptChk !== 'not_accepted';
            }
        },
        mounted(){
            this.callMeRecord()
            this.callLocation()
        },
        methods: {
            async callMeRecord(){
                this.recordMe = []
                try {
                    const res_me = await this.$http.get('/reserved/recode/me/')
                    this.recordMe = res_me.data.map( item => {
                        var kk =  this.timeCheckshowDel(item.created_at,item.status)
                        return {
                            'created_at': item.created_at,
                            'id': item.id,
                            'recode_date' : item.recode_date,
                            'recode_location': item.recode_location_name,
                            'recode_time': item.recode_time_name,
                            'status': item.status,
                            'btndelChk': kk,
                            'remark': item.remark !== null ? `<pre class="thai-font mb-0">${item.remark}</pre>` : '',
                        }
                    })
                    this.recordMe.sort((a, b) =>{ return b.id - a.id; });
                } catch (error) {}
            },
            timeCheckshowDel(timeChk,statusChk){
                var a = this.moment(timeChk)
                var b = this.moment(timeChk).add(15, 'minutes')
                var c = this.moment()
                if(statusChk === 'finished'){
                    return false   
                }else{
                    return c > b
                }
            },
            // controll
            fullControllLocation(){
                this.itemDay = []
                this.formData.time = null
                this.formData.date = ''
                this.caseReserved = ''
                this.callTime()
            },
            async callLocation(){
                this.locationData = []
                this.optionsLocation = []
                try {
                    const res = await this.$http.get('/reserved/location/')
                    if (res.status === 200) {
                        this.optionsLocation = res.data.map( item => {
                            return {
                                'value': item.id,
                                'text': item.name,
                            }
                        })
                        this.locationData = res.data.map( item => {
                            return {
                                'value': item.id,
                                'text': item.name,
                                'detail': item.detail,
                                'pre_booking' : item.pre_booking
                            }
                        })
                        // this.optionsLocation.push({value: null, text: 'Please select location' , disabled: true})
                        // this.optionsLocation.sort(function(a, b) {
                        //     var nameA = a.text.toUpperCase(); // ignore upper and lowercase
                        //     var nameB = b.text.toUpperCase(); // ignore upper and lowercase
                        //     if (nameA < nameB) { return -1; }
                        //     if (nameA > nameB) { return 1; }
                        //     // names must be equal
                        //     return 0;
                        // });
                        this.optionsLocation.sort((a, b) =>{ return b.value - a.value; }).push({value: null, text: 'Please select location' , disabled: true})
                    }
                } catch (error) {}
            },
            checkDetailData(idLocation , caseFilter){
                if(idLocation !== null){
                    var detail =  this.locationData.filter( (item)  => {
                        return item.value == idLocation;
                    }).map(itemX => {
                        return caseFilter === 'detail' ? itemX.detail  : itemX.pre_booking
                    })
                    return detail[0]
                }else{
                    return null
                }
            },
            async callTime(){
                this.optionsTime = []
                try {
                    const res = await this.$http.get(`/reserved/location/${this.formData.location}/period/`)
                    this.optionsTime = res.data.map( item => {
                        return {
                            'value': item.id,
                            'text': item.around,
                        }
                    })
                    this.optionsTime.sort((a, b) =>{ return b.value - a.value; }).push({value: null, text: 'Please select time' , disabled: true})
                    // this.optionsTime.push({value: null, text: 'Please select time' , disabled: true})
                    // this.optionsTime.sort(function(a, b) {
                    //     var nameA = a.text.toUpperCase(); // ignore upper and lowercase
                    //     var nameB = b.text.toUpperCase(); // ignore upper and lowercase
                    //     if (nameA < nameB) { return -1; }
                    //     if (nameA > nameB) { return 1; }
                    //     // names must be equal
                    //     return 0;
                    // }).push({value: null, text: 'Please select time' , disabled: true});
                } catch (error) {}
            },
            fullControll(){
                this.itemDay = []
                this.caseReserved = ''
                if(this.formData.time !== null){
                    this.callCheckQuata()
                }
            },
            async callCheckQuata(){
                this.free = 0
                this.limit = 0
                try {
                    // var dayFormat = this.moment(this.formData.date).format("YYYY-MM-DD")
                    // cheeck
                    this.itemDay = []
                    var AddPreBook = this.checkDetailData(this.formData.location , 'AddPreBook')
                    // console.log(parseInt(AddPreBook))
                    // loop date next 7 day
                    for (let indexDate = 0; indexDate < 7; indexDate++) {
                        var dayFormat = this.moment().add(indexDate+parseInt(AddPreBook), 'days').format("YYYY-MM-DD") 
                        const QuotaCheck = await this.$http.get(`/reserved/recode/checkquota/?recode_date=${dayFormat}&location=${this.formData.location}&period=${this.formData.time}`)
                        if (QuotaCheck.status === 200) {
                            this.itemDay.push(
                                {
                                    'a': this.moment(dayFormat).format('ddd LL'),
                                    'b':  QuotaCheck.data.free,
                                    'limit': QuotaCheck.data.limit,
                                    'user_permit': QuotaCheck.data.user_permit,
                                    'date_permit': QuotaCheck.data.date_permit,
                                }
                            )
                        }
                    }
                    // loop date next 7 day
                } catch (error) {}
            },
            async addReserved(){
                var dayFormat = this.moment(this.formData.date).format("YYYY-MM-DD")
                // var day = this.moment(this.formData.date)
                // var currentday = this.moment()
                const sendData = new FormData()
                sendData.append('recode_location', this.formData.location)
                sendData.append('recode_date', dayFormat)
                sendData.append('recode_time', this.formData.time)
                sendData.append('remark', this.formData.remark)
                try {
                    const response = await this.$http.post('/reserved/recode/add/',
                        sendData,
                        {
                            headers: { 'Content-Type': 'multipart/form-data' }
                        }
                    )
                    if(response.status === 200){
                        this.itemDay = []
                        this.formData = Object.assign({}, formReserved)
                        this.callMeRecord()
                        this.caseReserved = ''
                        this.$refs['bv-modal-con'].hide()
                    }else{
                        throw { response }
                    }
                } catch (error) {}
            },
            // 2
            async delReserved(id){
                try {
                    const res = await this.$http.delete(`/reserved/recode/${id}/remove/`)
                    if(res.status === 200){
                        this.itemDay = []
                        this.caseReserved = ''
                        this.formData = Object.assign({}, formReserved)
                        this.callMeRecord()
                        this.$refs['bv-modal-del'].hide()
                    }
                } catch (error) {}
            },
            handleResize() {
                this.window.width = window.innerWidth;
                this.window.height = window.innerHeight;
                if(this.window.width <= 1200){
                    this.MaxScale = 'miniMonitor'
                }else{
                    this.MaxScale = 'Monitor'
                }
            },
            zeroPad(num) {
                return num.toString().padStart(6, "0");
            },
            maplocation(id){
                var lo =  this.locationData.filter( (item)  => {
                    return item.value == id;
                }).map(itemX => {
                    return  itemX.text
                })
                return lo[0]
            },
            maptime(id){
                var time =  this.optionsTime.filter( (item)  => {
                    return item.value == id;
                }).map(itemX => {
                    return  itemX.text
                })
                return time[0]
            },
            addConfirm(item,daybook){
                this.confirmModal.text_1 = this.maplocation(this.formData.location)
                this.confirmModal.text_2 = this.moment(daybook).format('ddd LL')
                this.confirmModal.text_3 = this.maptime(this.formData.time)
                this.formData.date = daybook
                this.$refs['bv-modal-con'].show() 
            },
            closeReserved(){
                this.$refs['bv-modal-con'].hide() 
            },
            infoDel(id1,id2) {
                this.infoModal.id1 = id1
                this.infoModal.id2 = id2
                this.$refs['bv-modal-del'].show()
            },
            DelReserved(){
                this.$refs['bv-modal-del'].hide() 
            }
        }
    }
</script>

